var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M18 2a2 2 0 0 1 2 2v16.057c0 1.627-1.839 2.573-3.163 1.627L12 18.23l-4.838 3.455C5.84 22.63 4 21.684 4 20.057V4a2 2 0 0 1 2-2zm0 2H6v16.057l4.838-3.456a2 2 0 0 1 2.325 0L18 20.057z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }